<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;"></div>
      <export-components v-if="!isAuditViewOnly" :apiFunction="exportContract" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex"></el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)" :key="activeTab"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true"
      :table-col-check="{isShow:true,name:'Impairment3' + activeTab}">
      <div slot="operation" slot-scope="{record}">
        <el-button size="mini" type="success" @click="handleDetails(record)">查看详情</el-button>
        <el-button size="mini" type="primary" color="#ffffff" v-if="record.contractFilePath" icon="el-icon-download"
          @click="download(record)">下载合同</el-button>
        <el-button size="mini" type="warning" v-if="record['impairmentFlag'] !== 1 && !isAuditViewOnly"
          @click="impairment(record)">转预付款</el-button>
      </div>
      <div slot="contractName" slot-scope="{text,record,index,column}">
        <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
      </div>
      <div slot="executeContractNumber" slot-scope="{text,record}">
       <div v-if="text">
          <span>{{ text }}</span>
          <el-tooltip content="复制">
            <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
          </el-tooltip>
        </div>
        <span v-else>{{'NA'}}</span>
      </div>
      <div slot="invoicedAmount" slot-scope="{text,record}">
        <span
          v-if="['PREPAYMENTS','FORMAL','IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId']">{{
          text }}</span>
        <span v-else>{{ 'NA' }}</span>
      </div>
      <div slot="invoicingAmount" slot-scope="{text,record}">
        <span
          v-if="['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(record.contractType) && !record['sourceIntentProjectId']">{{
          Number(record['contractAmount']) - Number(record['invoicedAmount']) }}</span>
        <span v-else>{{ 'NA' }}</span>
      </div>
      <div slot="addedAmount" slot-scope="{text,record}">
        <span v-if="['PREPAYMENTS','IMPORT_PREPAYMENTS'].includes(record.contractType)">{{text}}</span>
        <span v-else>{{'NA'}}</span>
      </div>
      <div slot="contractType" slot-scope="{text,record}">
        <div class="status-tag-container">
          <el-tag :type="getContractColor(text, 'tagType')" :style="{
            color: getContractColor(text, 'color'),
            'background-color': getContractColor(text, 'backgroundColor'),
            'border-color': getContractColor(text, 'borderColor')
          }">{{ getContractColor(text, 'name') }}</el-tag>
        </div>
      </div>
      <div slot="impairmentFlag" slot-scope="{text,record}">
        <div class="status-tag-container">
          <el-tag v-if="text === 0" type="danger">否</el-tag>
          <span v-else-if="text === 1" style="display: flex;align-items: center">
            <el-tag type="success">是</el-tag>
            <el-tooltip effect="dark" style="margin-left:5px" content="查看转预付款信息" placement="bottom">
              <el-link type="primary" :underline="false" @click="showImpairmentDetail(record)"><i
                  v-html="viewDetailIcon"></i></el-link>
            </el-tooltip>
          </span>
        </div>
      </div>
      <div slot="contact" slot-scope="{text,record}">
        <el-tooltip effect="dark" content="查看客户信息" placement="bottom" v-if="text">
          <el-link type="primary" :underline="false" @click="showContact(record)"><i
              v-html="viewDetailIcon"></i></el-link>
        </el-tooltip>
        <span>{{text}}</span>
      </div>
      <div slot="contractNumber" slot-scope="{text,record,index,column}">
        <span>{{text}}</span>
        <el-tooltip content="复制">
          <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
        </el-tooltip>
      </div>
      <div slot="filterContractType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='预付款'>预付款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='正式'>正式</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='扣款'>扣款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='老系统预付款'>老系统预付款</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='研发'>研发</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
      <div slot="contractChangeFlag" slot-scope="{text,record}">
        <div class="status-tag-container">
          <el-tag v-if="text" type="success">是</el-tag>
          <el-tag v-else type="danger">否</el-tag>
        </div>
      </div>
      <div slot="rawDataReleaseStatus" slot-scope="{text,record}">
        <div v-if="text" class="status-tag-container">
          <el-tag v-if="text === 'ALL_RELEASE'" type="success">已释放</el-tag>
          <el-tag v-else-if="text === 'PARTIAL_RELEASE'" type="primary">部分释放</el-tag>
          <el-tag v-else-if="text === 'NOT_RELEASED'" type="warning">未释放</el-tag>
        </div>
        <div v-else class="status-tag-container">
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='是'>是</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='否'>否</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
      <div slot="filterRawDataReleaseStatus"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='未释放'>未释放</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='部分释放'>部分释放</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已释放'>已释放</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <contract-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="[showDetails]"
      @submit="close">
    </contract-details>
    <add-impairment v-if="showAddImpairmentDialog" :show-dialog="showAddImpairmentDialog"
      :select-detail="showImpairment" @submit="closeAdd"></add-impairment>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
    <impairment-info :show-dialog="showImpairmentInfo" v-if="showImpairmentInfo" :select-detail="impairmentInfo"
      @submit="closeShowImpairment"></impairment-info>
  </div>
</template>

<script>
import {attachmentContract, exportContract, getContractPage} from "@/api/dilivery/sales/contract";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import { impairment } from "@/utils/data/tableCol/impairment/impairment";
import ExFoldTable from "@/components/ExFoldTable.vue";
import AddImpairment from "@/components/impairment/AddImpairment.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import {viewDetailIcon} from "@/utils/icon";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import {copyText} from "@/utils/windowsUtils";
import {getContractColor} from "@/color";
import ImpairmentInfo from "@/components/impairment/ImpairmentInfo.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "Impairment",
  components: {
    ImpairmentInfo,
    CustomerUserInfo,
    ExportComponents, PictureLoading, AddImpairment,ExFoldTableCell, ExFoldTable, TableHeadNote, ContractDetails},
  mixins: [tableOperationMixin, auditViewOnlyMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '未转预付款', name: 'not', showBadge: false },
        { label: '已转预付款', name: 'had', showBadge: false },
      ],
      sendData: {
        all: { "query#receiptStatus.EQ": "PAYMENT_RECEIVED", "query#contractType.EQ": "FORMAL" },
        not: { "query#receiptStatus.EQ": "PAYMENT_RECEIVED", "query#contractType.EQ": "FORMAL", "query#impairmentFlag.EQ": 0 },
        had: { "query#receiptStatus.EQ": "PAYMENT_RECEIVED", "query#contractType.EQ": "FORMAL", "query#impairmentFlag.EQ": 1 },
      },
      pageTotal: { all: 0, not: 0, had: 0 },
      activeTab: 'all',
      loading: true,
      contactInfo: [],
      showContactInfo: false,
      impairmentInfo: {},
      showImpairmentInfo: false,
      viewDetailIcon: viewDetailIcon,
      option: [
        { label: '合同审核时间', value: 'operatingTime' },
        { label: '合同拟定时间', value: 'contractDraftingDate' },
        { label: '创建时间', value: 'createTime' },
      ],
      selectDetail: '',
      showDetailsDialog: false,
      showDetails: '',
      showAddImpairmentDialog: false,
      showImpairment: '',
      showAddComplementDialog: false,
      showComplement: '',
    }
  },
  computed: {
    columns() {
      let cols = impairment(this.searchConditionTag || {}).filter(item => !['contractMails','status'].includes(item.key));
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getContractColor,
    exportContract,
    showContact(row) {
      this.contactInfo = [row.customerContacts]
      this.showContactInfo = true
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showImpairmentDetail(row) {
      this.impairmentInfo = row
      this.showImpairmentInfo = true
    },
    closeShowImpairment() {
      this.showImpairmentInfo = false
    },
    async download(row) {
      try {
        let url = `${baseURL}/sequencing-contract/attachment/${row.id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role") }`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    complements(row) {
      this.showComplement = row
      this.showAddComplementDialog = true
    },
    copyData(text) {
      copyText(text)
      this.$messageUi.success('复制成功')
    },
    handleCommand(command, row) {
      switch (command) {
        case "download": this.download(row); break;
        case "impairment": this.impairment(row); break;
        case "complements": this.complements(row); break;
        default: break;
      }
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getContractPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          if (this.searchConditionTag.some(condition => condition.key === 'sourceIntentProjectId' && condition.value === '正式合同结余')) {
            this.tableData = this.tableData.filter(record => record['sourceIntentProjectId']);
          }
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      let data = ['baseCompanyName', 'customerContactsName', 'salesName', 'trusteeContactsName','customerCompanyName']
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'contractType') {
          if (item.value === '预付款') {
            value = 'PREPAYMENTS'
          } else if (item.value === '老系统预付款') {
            value = 'IMPORT_PREPAYMENTS'
          } else if (item.value === '研发') {
            value = 'DEVELOPMENT'
          } else if (item.value === '正式') {
            value = 'FORMAL'
          } else {
            value = 'CHARGEBACKS'
          }
        } else if (item.key === 'impairmentFlag') {
          value = item.value === '是' ? 1 : 0
        } else if (item.key === 'status') {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else if (item.value === '已驳回') {
            value = 'DEFEAT'
          } else if (item.value === '待评估') {
            value = 'EVALUATING'
          } else if (item.value === '已废弃') {
            value = 'DERELICT'
          } else {
            value = 'CONTRACT_TO_BE_SUBMITTED'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        } else if (item.key === 'rawDataReleaseStatus') {
          if (item.value === '未释放') {
            value = 'NOT_RELEASED'
          } else if (item.value === '部分释放') {
            value = 'PARTIAL_RELEASE'
          } else {
            value = 'ALL_RELEASE'
          }
        }
        if (data.includes(item.key)) {
          sendData[item.key] = value
        } else if (['contractType','rawDataReleaseStatus'].includes(item.key)) {
          sendData["query#" + item.key + ".EQ"] = value
        } else if (item.key === 'sourceIntentProjectId') {
          // skip
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    handleEdit(row) {
      this.selectDetail = row
      this.showCheckDialog = true
    },
    handleDetails(row) {
      this.showDetails = row
      this.showDetailsDialog = true
    },
    impairment(row) {
      this.showImpairment = row
      this.showAddImpairmentDialog = true
    },
    close() {
      this.$nextTick(() => {
        this.showDetailsDialog = false
      })
    },
    closeAdd(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddImpairmentDialog = false
      })
    },
    closeAddC(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddComplementDialog = false
      })
    },
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
